// Utilidades de fecha para zona horaria de Mexicali / Tijuana.
// Todas las fechas en formato YYYY-MM-DD se manipulan como strings puros,
// evitando conversiones automáticas a UTC del objeto Date.

const TZ = 'America/Tijuana';

/**
 * Retorna la fecha actual de Mexicali/Tijuana como string YYYY-MM-DD.
 * Usa Intl.DateTimeFormat con la zona horaria correcta para evitar
 * que el offset UTC del navegador (o del servidor) cambie el día.
 */
export function todayMx() {
  const fmt = new Intl.DateTimeFormat('en-CA', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit' });
  // en-CA devuelve YYYY-MM-DD directamente
  return fmt.format(new Date());
}

/**
 * Retorna un objeto {year, month, day} local de Mexicali para la fecha actual.
 */
export function nowMxParts() {
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date());
  const map = {};
  parts.forEach(p => { map[p.type] = p.value; });
  return map;
}

/**
 * Suma (o resta si delta negativo) días a un string YYYY-MM-DD y devuelve otro string YYYY-MM-DD.
 * NUNCA pasa por new Date(stringUtc) para evitar corrimiento de día por UTC.
 */
export function shiftDateStr(dateStr, delta) {
  if (!dateStr || typeof dateStr !== 'string') return dateStr;
  const [y, m, d] = dateStr.split('-').map(Number);
  // Usar Date.UTC para operar en un timestamp neutro y luego re-extraer UTC parts (no zona local)
  const t = Date.UTC(y, (m || 1) - 1, d || 1) + delta * 86400000;
  const dt = new Date(t);
  const yy = dt.getUTCFullYear();
  const mm = String(dt.getUTCMonth() + 1).padStart(2, '0');
  const dd = String(dt.getUTCDate()).padStart(2, '0');
  return `${yy}-${mm}-${dd}`;
}

/**
 * Retorna un objeto Date centrado al mediodía local del navegador
 * representando el día `dateStr` (YYYY-MM-DD). Útil para pasar a date-fns
 * (startOfWeek, addDays, etc.) sin sufrir corrimientos por UTC.
 */
export function dateFromMxStr(dateStr) {
  if (!dateStr) return null;
  const [y, m, d] = String(dateStr).split('-').map(Number);
  return new Date(y, (m || 1) - 1, d || 1, 12, 0, 0);
}

/** Objeto Date equivalente a la fecha actual de Mexicali, al mediodía local. */
export function todayMxDate() {
  return dateFromMxStr(todayMx());
}

/**
 * Formato humano de una fecha YYYY-MM-DD en español ('vie, 28 jul 2026').
 */
export function fmtDateMx(dateStr) {
  if (!dateStr) return '';
  const [y, m, d] = String(dateStr).split('-').map(Number);
  const dt = new Date(Date.UTC(y, (m || 1) - 1, d || 1, 12, 0, 0));
  return new Intl.DateTimeFormat('es-MX', { timeZone: TZ, weekday: 'short', day: '2-digit', month: 'short', year: 'numeric' }).format(dt);
}
